/** MEDIA-HEIC-SERVER-PREVIEW-PROFILE-A1 — prepare-layer constants. */

export const PREPARE_STATES = Object.freeze({
  selected: "selected",
  native_check_pending: "native_check_pending",
  native_ready: "native_ready",
  server_preview_pending: "server_preview_pending",
  server_preview_ready: "server_preview_ready",
  failed: "failed",
  cancelled_ui: "cancelled_ui",
});

/** Surfaces that require OD-4 explicit confirmation before server preview. */
export const CONFIRM_SERVER_SURFACES = Object.freeze([
  "profile_avatar",
  "chat_logo",
]);

/** Advisory compressed-size cutoff for immediate server routing (not OOM proof). */
export const SERVER_ROUTE_BYTE_THRESHOLD = 8 * 1024 * 1024; // 8 MiB

/** Browser comfort guard — release native bitmap and route to server. */
export const NATIVE_MAX_PIXELS = 16_000_000; // 16 MP

/** Browser fetch timeout for server preview. */
export const SERVER_PREVIEW_TIMEOUT_MS = 60_000;

export const SERVER_PREVIEW_CONFIRM_MESSAGE =
  "Оригінальне зображення буде безпечно надіслано на сервер для підготовки редагованого попереднього перегляду. Продовжити?";

export const SERVER_PREVIEW_ENDPOINT = "/media/image-preview/";
